import React from 'react'
import { Loader } from 'semantic-ui-react';

import CountCardHeader from './../Drive/Cards/CountCardHeader';
import ThreeBlockDivision from './../Drive/Cards/ThreeBlockDivision'
import organization from "../../../../images/svg/noti-community.svg";

class CountBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    componentWillMount() {
        this.setState({ loading: true });
        setTimeout(
            function () {
                this.setState({ loading: false });
            }
                .bind(this),
            2500
        );
    }

    render() {
        let showLoader = this.state.loading || this.props.loadingMyOrganization || this.props.loadingOrganization;
        return (
            <div>
                <div className="display-flow-root">
                    <CountCardHeader
                        name="Community"
                        type="community"
                        image={organization}
                        totalCount={this.props.organizationCountData && this.props.organizationCountData.total}
                        selectedOrganisation={this.props.selectedOrganisation}
                        selectedAccount={this.props.selectedAccount}
                    />
                </div>
                {showLoader &&
                    <div className="setLoader" style={{ padding: "17px 0" }}>
                        <Loader active inline />
                    </div>}
                <div className="count-content">
                    <ThreeBlockDivision
                        type="community"
                        label1Name="Teams"
                        label1Count={showLoader ? 0 : this.props.organizationCountData ? this.props.organizationCountData.totalSubOrganization : 0}
                        label2Name="Users"
                        label2Count={showLoader ? 0 : this.props.allOrgUsers ? this.props.allOrgUsers : 0}
                        label3Name="Invitations"
                        label3Count={showLoader ? 0 : this.props.organizationCountData ? this.props.organizationCountData.invitationSend : 0}
                        history={this.props.history}
                        isLoadingData={this.props.isLoadingData}
                        selectedOrganisation={this.props.selectedOrganisation}
                    />

                </div>
            </div>
        )
    }
}

export default CountBlock;